//@dependencies
import PropTypes from "prop-types";
//@mui
import { CircularProgress } from "@mui/material";

//styles
import styles from "./FormPopup.module.scss";
import blueOopsIcon from "../../GlobalAssets/svg/blue-oops.svg";
import redOopsIcon from "../../GlobalAssets/svg/red-oops.svg";
import yellowOopsIcon from "../../GlobalAssets/svg/yellow-oops.svg";
import greenOopsIcon from "../../GlobalAssets/svg/green-oops.svg";

function FormPopup(props) {
  //props and hooks
  const {
    trigger,
    // cancel,
    cancelFunction,
    cancelTitle,
    // setTrigger,
    type,
    title,
    subtitle,
    button,
    buttonFunction,
    buttonTitle,
    buttonTitle1,
    buttonFunction1,
    loading,
    // handover,
    // ...rest
  } = props;

  const buttonColors = {
    warning: "#E39014",
    error: "#AE1B17",
    info: "#135FC2",
    success: "#129255",
    loading: "#135FC2",
    staging: "#135FC2",
  };

  // Define button style dynamically based on type
  const buttonStyle =
    type === "staging"
      ? { fontSize: "16px", padding: "8px 16px", width: "130px" }
      : { fontSize: "16px", padding: "10px 20px" };

  return (
    <>
      {trigger && (
        <div className={styles.popupContainer}>
          <div className={styles.popupBox}>
            <div
              style={{
                width: "100%",
                height: "144px",
                borderRadius: "8px 8px 0px 0px",
                display: "flex",
                padding: "20px 0",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {type === "loading" && (
                <img
                  src={blueOopsIcon}
                  alt="yellow-oops"
                  style={{
                    height: "200px",
                    marginTop: "60px",
                    marginBottom: "30px",
                  }}
                />
              )}
              {type === "warning" && (
                <img
                  src={yellowOopsIcon}
                  alt="red-oops"
                  style={{ height: "150px", marginTop: "60px" }}
                />
              )}

              {type === "error" && (
                <img
                  src={redOopsIcon}
                  alt="red-oops"
                  style={{ height: "150px", marginTop: "60px" }}
                />
              )}

              {type === "success" && (
                <img
                  src={greenOopsIcon}
                  alt="green-oops"
                  style={{
                    height: "150px",
                    marginTop: "60px",
                    marginBottom: "30px",
                  }}
                />
              )}

              {type === "info" && (
                <img
                  src={blueOopsIcon}
                  alt="blue-oops"
                  style={{
                    height: "150px",
                    marginTop: "60px",
                    marginBottom: "30px",
                  }}
                />
              )}
            </div>

            <div className={styles.textContainer}>
              <div>
                <div className={styles.popupTitle}>{title}</div>
                <div className={styles.popupsubtitle}>{subtitle}</div>
                {button && (
                  <div
                    style={{
                      marginTop: "25px",
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <button
                      onClick={() => {
                        if (!loading) {
                          buttonFunction();
                        }
                      }}
                      className={styles.popupButton}
                      style={{
                        ...buttonStyle,
                        backgroundColor: buttonColors[type],
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={18} color={"inherit"} />
                      ) : (
                        buttonTitle
                      )}
                    </button>

                    {cancelTitle ? (
                      <button
                        onClick={() => {
                          if (!loading) {
                            cancelFunction();
                          }
                        }}
                        className={styles.popupCancel}
                        style={{
                          ...buttonStyle,
                          color: buttonColors[type],
                          border: `1px solid ${buttonColors[type]}`,  
                        }}
                      >
                        {cancelTitle}
                      </button>
                    ) : (
                      ""
                    )}

                    {type === "staging" && (
                      <button
                        onClick={buttonFunction1}
                        className={styles.popupButton}
                        style={buttonStyle}
                      >
                        {buttonTitle1}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FormPopup;

//types
FormPopup.propTypes = {
  trigger: PropTypes.bool,
  // cancel: PropTypes.bool,
  // setTrigger: PropTypes.func,
  type: PropTypes.oneOf(["loading", "warning", "success", "info", "error"]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  button: PropTypes.bool,
  buttonFunction: PropTypes.func,
  buttonTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  cancelFunction: PropTypes.func,
};
